import type React from "react";
import type { ReelKey } from "./catalog";
import { BRANDS_DURATION, BrandsReel } from "./brands/BrandsReel";
import { CARDS_DURATION, CardsReel } from "./cards/CardsReel";
import { HALLOWEEN_DURATION, HalloweenReel } from "./halloween/HalloweenReel";
import { LOULENN_DURATION, LoulennReel } from "./loulenn/LoulennReel";
import { QUIZ_DURATION, QuizReel } from "./quiz/QuizReel";
import { SLOTS_DURATION, SlotsReel } from "./slots/SlotsReel";
import { SPLIT_DURATION, SplitReel } from "./split/SplitReel";
import { TICKET_DURATION, TICKET_FPS, TicketReel } from "./ticket/TicketReel";
import { REEL } from "./ui/ReelFrame";

/**
 * Component of each reel with its own folder (`reel` in `catalog.ts`).
 * Only maps: timing stays in the reel's module, which the video server
 * fingerprints (this file isn't part of any reel's template).
 */
export const REEL_COMPONENTS = {
  ticket: {
    component: TicketReel,
    durationInFrames: TICKET_DURATION,
    fps: TICKET_FPS,
  },
  cards: {
    component: CardsReel,
    durationInFrames: CARDS_DURATION,
    fps: REEL.fps,
  },
  quiz: { component: QuizReel, durationInFrames: QUIZ_DURATION, fps: REEL.fps },
  split: {
    component: SplitReel,
    durationInFrames: SPLIT_DURATION,
    fps: REEL.fps,
  },
  slots: {
    component: SlotsReel,
    durationInFrames: SLOTS_DURATION,
    fps: REEL.fps,
  },
  loulenn: {
    component: LoulennReel,
    durationInFrames: LOULENN_DURATION,
    fps: REEL.fps,
  },
  brands: {
    component: BrandsReel,
    durationInFrames: BRANDS_DURATION,
    fps: REEL.fps,
  },
  halloween: {
    component: HalloweenReel,
    durationInFrames: HALLOWEEN_DURATION,
    fps: REEL.fps,
  },
} satisfies Record<
  ReelKey,
  { component: React.FC; durationInFrames: number; fps: number }
>;
